import i18n from 'i18next'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { httpRequest } from '../common/network'
import { setLocale } from './features/locale/localeSlice'

const useLocale = (): void => {
    const dispatch = useDispatch()

    useEffect(() => {
        httpRequest({
            method: 'GET',
            path: 'help/locale',
            onSuccess: (res: { data: string }) => {
                void i18n.changeLanguage(res.data)
                dispatch(setLocale({ value: res.data }))
            },
        })
    }, [])
}

export default useLocale
